import { householdConstants } from "@constants";

const initalState = {
  query: {
    loading: false,
    constructionUuid: null,
    condition: {},
    total: 0,
    items: [],
    fail: null
  },
  list: {
    loading: false,
    items: [],
    fail: null
  }
};

export const households = (state = initalState, action) => {
  switch (action.type) {
    case householdConstants.GET_ALL_REQUEST:
      return {
        ...state,
        query: {
          ...initalState.query,
          loading: true
        }
      };
    case householdConstants.GET_ALL_SUCCESS:
      const { total, items, condition, constructionUuid } = action;
      return {
        ...state,
        query: {
          ...initalState.query,
          loading: false,
          constructionUuid,
          condition,
          total,
          items
        }
      };
    case householdConstants.GET_ALL_FAILURE:
      const { error } = action;
      return {
        ...state,
        query: {
          ...initalState.query,
          loading: false,
          fail: error
        }
      };
    case householdConstants.GET_LIST_REQUEST:
      return {
        ...state,
        list: {
          ...initalState.list,
          loading: true
        }
      };
    case householdConstants.GET_LIST_SUCCESS:
      const { items: listItems } = action;
      return {
        ...state,
        list: {
          ...initalState.list,
          loading: false,
          items: listItems
        }
      };
    case householdConstants.GET_LIST_FAILURE:
      return {
        ...state,
        list: {
          ...initalState.list,
          loading: false,
          fail: action.error
        }
      };
    case householdConstants.RESET_LIST_SUCCESS:
      return {
        ...state,
        list: initalState.list
      };
    case householdConstants.RESET_ALL_SUCCESS:
      return initalState;
    default:
      return state;
  }
};
